export const responsiveTopPadding = { SM: 0, MD: 0, LG: 0, XL: 0 }
